import React, { useEffect } from 'react'

import { publishViewCartEvent } from '../../../lib/analytics/cart'
import { useCartContext } from '../../../lib/cart'
import Cart from './Cart'

const CartContainer: React.FC = () => {
  const { cart } = useCartContext()

  useEffect(() => {
    if (!cart) {
      return
    }
    publishViewCartEvent(cart)
  }, [cart])

  if (!cart) {
    return null
  }

  return <Cart cart={cart} />
}

export default CartContainer
